/* eslint-disable unicorn/filename-case */
import { TeamsUserCredential, UserInfo } from "@microsoft/teamsfx";
import { createContext, Dispatch, SetStateAction } from "react";
import { Theme } from "@fluentui/react-components";
import { QueryClient } from "react-query";
import { app, HostClientType } from "@microsoft/teams-js";
import { IAuthCallResponse } from "../types/CommonTypes";

export const TCTeamsFxContext = createContext<{
  configuration: any;
  isLoginFromBot: boolean;
  userConfiguration: any;
  teamcenterLanguage: any;
  teamcenter: {
    session: IAuthCallResponse;
    setSession: (value: IAuthCallResponse) => void;
    isAuthenticated: boolean;
    setTCisAuthenticated: (value: boolean) => void;
    isAuthenticating: boolean;
    logout: () => void;
    login: () => Promise<void>;
    setLogin: (teamcenterCode: IAuthCallResponse) => Promise<void>;
    siteDisplay: string;
  };
  failure: {
    error:
      | {
          title: string;
          message: string;
          statusCode: number;
          correlationId: string;
        }
      | undefined;
    setError: Dispatch<
      SetStateAction<
        | {
            title: string;
            message: string;
            statusCode: number;
            correlationId: string;
          }
        | undefined
      >
    >;
  };
  queryClient: QueryClient;
  i18n: { [key: string]: string };
  scopesArray: Array<string>;
  isLoginGraph: boolean;
}>({} as never);
